import axiosInstance from '../../translator';
import { testTakerApi } from '../../constants/apis/apiEndpoints';

export const updateTestTakerDetails = async (payload) => {
  return axiosInstance
      .patch(`${testTakerApi?.updateTestTakerDetails}/${payload.test_taker_id}`, {
          "first_name": payload?.first_name,
          "last_name": payload?.last_name || '',
      })
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error;
    });
};

export const searchTestTaker = async (email_id, paginationModel) => {
  const offset = paginationModel?.page + 1
  return axiosInstance
    .get(
      `${testTakerApi?.searchTestTaker}?email_id=${email_id}&limit=${paginationModel?.pageSize}&offset=${offset}`
    )
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteTestTakerOnboardingImage = async (payload) => {
  return axiosInstance
      .patch(`${testTakerApi?.updateTestTakerDetails}/${payload.test_taker_id}?reset_onboarding=True`)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error;
    });
}